import React from 'react';
import { ChevronDown } from 'lucide-react';

// Select Dropdown Component
const SelectDropdown = ({ value, onChange, options, placeholder }) => (
    <div className="relative">
        <select
            value={value}
            onChange={onChange}
            className="w-full appearance-none bg-white border border-stone-200 rounded-lg px-3 py-2.5 text-sm text-stone-700 outline-none focus:border-stone-400 pr-8"
        >
            <option value="">{placeholder}</option>
            {options.map((opt, idx) => (
                <option key={idx} value={typeof opt === 'string' ? opt : opt.id}>
                    {typeof opt === 'string' ? opt : opt.name}
                </option>
            ))}
        </select>
        <ChevronDown className="w-4 h-4 text-stone-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
    </div>
);

export default SelectDropdown;
